module.exports = __webpack_public_path__ + "media/images/wedding/events/wedding-2dda658b8fea0cea4a1e82877620d489.jpg";